export type OrdersTab = 'order_queue' | 'order_history' | 'order_issues'

const TIME_COLUMN_KEYS: Record<OrdersTab, [string, string]> = {
  order_queue: ['planned_preparation_start', 'planned_end_time'],
  order_history: ['start_time', 'end_time'],
  order_issues: ['start_time', 'end_time']
}

const LAST_COLUMN_KEYS: Record<OrdersTab, string[]> = {
  order_queue: ['actions'],
  order_history: [],
  order_issues: []
}

export const columnKeys = (tab: OrdersTab): string[] => [
  'meal',
  'locker',
  'unit',
  'measured_meal_weight',
  'order_status',
  'order_received',
  ...TIME_COLUMN_KEYS[tab],
  ...LAST_COLUMN_KEYS[tab]
]

export const columnCount = (tab: OrdersTab): number => columnKeys(tab).length
